import { DataLoadingComponent } from '@/components/data-loading/data-loading.component';
import { NgIf } from '@angular/common';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { PropertiesService, RealProperty, RealPropertySummaryLocation } from '@eemo/api-client';
import * as L from 'leaflet';
import { Subscription } from 'rxjs';
import { InitDataCoord } from '../../interfaces/InitData.interface';
import { MapService } from '../../services/MapService.service';
import { NewMapComponent } from '../new-map/new-map.component';
import { AddressFoundBySearch, SearchMapComponent } from '../search-map/search-map.component';

@Component({
  selector: 'app-map-wrapper',
  templateUrl: './map-wrapper.component.html',
  styleUrls: ['./map-wrapper.component.scss'],
  standalone: true,
  imports: [SearchMapComponent, NewMapComponent, NgIf, DataLoadingComponent]
})
export class MapWrapperComponent implements OnInit, OnDestroy {
  @Input() initMapCoord: InitDataCoord | null = null;
  @Input() initZoom = 17;
  @Input() hasSatelliteView = true;
  @Input() hasPlanView = false;
  @Input() hasCadastreView = false;
  @Input() hasEventParcelles: boolean;
  @Input() hasLayerControls = true;
  @Input() isLocateEnabled = true;
  @Input() searchEnabled = false;
  @Input() updateLocationEnabled = false;

  @Output() locationUpdated = new EventEmitter<Location>();

  props: RealPropertySummaryLocation[] = [];
  loading = false;
  dataWithLocation = false;
  mapService: MapService;

  sub = new Subscription();

  constructor(private propertyService: PropertiesService) {}

  ngOnInit(): void {
    this.loading = true;
    this.sub = this.propertyService.getRealPropertyLocationSummaryList().subscribe({
      next: (d) => {
        this.props = d;
        for (const prop of this.props) {
          if (prop.location) {
            this.dataWithLocation = true;
            break;
          }
        }
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      }
    });
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  onMapInstance(mapService: MapService) {
    this.mapService = mapService;
  }

  onAddressFound(dataSearch: AddressFoundBySearch) {
    this.panMapTo(dataSearch.data[0].lat, dataSearch.data[0].lon);
    if (this.mapService.markerAddress) {
      this.mapService.map.removeLayer(this.mapService.markerAddress);
    }
    const iconAddress = L.icon({
      iconRetinaUrl: 'assets/map/marker-icon-address-2x.png',
      iconUrl: 'assets/map/marker-icon-address.png',
      iconSize: [25, 34],
      iconAnchor: [12, 34],
      tooltipAnchor: [12, -20]
    });
    this.mapService.markerAddress = L.marker([dataSearch.data[0].lat, dataSearch.data[0].lon], {
      icon: iconAddress
    }).bindTooltip(dataSearch.searched);
    this.mapService.map.addLayer(this.mapService.markerAddress);
  }

  onPropertyFound(prop: RealProperty) {
    this.panMapTo(prop.location.latitude, prop.location.longitude);
  }

  panMapTo(lat: number, lon: number) {
    this.mapService.map.setZoom(this.initZoom);
    this.mapService.map.panTo(L.latLng(lat, lon), {
      animate: true,
      duration: 1
    });
  }
}
